import service from 'modules/service';
import { intl } from 'modules/i18n';
import { getUserProfile } from 'modules/auth/selectors';
import { loadUserProfile } from 'modules/auth/actions';
import { EVENT_CATEGORY } from 'modules/common/constants';
import { confirm, getErrorText, showErrorSnackbar } from 'modules/common/utils';
import * as storeActions from './storeActions';

export const addClientRole = (memberId, clientId, role) => async (dispatch, getState) => {
    const confirmation = await confirm({
        title: intl.formatMessage({ id: 'admin.addRole' }),
        messages: [ intl.formatMessage({ id: 'admin.addRoleConfirmationMessage' }) ],
        confirmButtonText: intl.formatMessage({ id: 'common.confirm' }),
        cancelButtonText: intl.formatMessage({ id: 'common.cancel' }),
        cancelButtonClass: 'btn-flat'
    });

    if (confirmation) {
        dispatch(storeActions.setClientMembershipsListOperationInProgress(true));

        try {
            await service.api.addClientRole(memberId, clientId, role);

            service.analytics.trackEvent('Add client member role', EVENT_CATEGORY.ADMIN, role);

            dispatch(storeActions.addClientMemberRole({ memberId, role }));

            const { id } = getUserProfile(getState());
            if (id === memberId) {
                await dispatch(loadUserProfile());
            }
        } catch (err) {
            showErrorSnackbar(getErrorText(err));
        } finally {
            dispatch(storeActions.setClientMembershipsListOperationInProgress(false));
        }
    }
};

export const deleteClientMembership = (memberId, clientId) => async (dispatch, getState) => {
    const confirmation = await confirm({
        title: intl.formatMessage({ id: 'admin.revokeMembership' }),
        messages: [ intl.formatMessage({ id: 'admin.clientRevokeMembershipConfirmationMessage' }) ],
        confirmButtonText: intl.formatMessage({ id: 'common.confirm' }),
        confirmButtonClass: 'btn-negative',
        cancelButtonText: intl.formatMessage({ id: 'common.cancel' }),
        cancelButtonClass: 'btn-flat'
    });

    if (confirmation) {
        dispatch(storeActions.setClientMembershipsListOperationInProgress(true));

        try {
            await service.api.deleteClientMembership(memberId, clientId);

            service.analytics.trackEvent('Revoke client membership', EVENT_CATEGORY.ADMIN);

            dispatch(storeActions.removeClientMembership({ memberId }));

            const { id } = getUserProfile(getState());
            if (id === memberId) {
                await dispatch(loadUserProfile());
            }
        } catch (err) {
            showErrorSnackbar(getErrorText(err));
        } finally {
            dispatch(storeActions.setClientMembershipsListOperationInProgress(false));
        }
    }
};

export const deleteClientRole = (memberId, clientId, role) => async (dispatch, getState) => {
    const confirmation = await confirm({
        title: intl.formatMessage({ id: 'admin.removeRole' }),
        messages: [ intl.formatMessage({ id: 'admin.removeRoleConfirmationMessage' }) ],
        confirmButtonText: intl.formatMessage({ id: 'common.confirm' }),
        confirmButtonClass: 'btn-negative',
        cancelButtonText: intl.formatMessage({ id: 'common.cancel' }),
        cancelButtonClass: 'btn-flat'
    });

    if (confirmation) {
        dispatch(storeActions.setClientMembershipsListOperationInProgress(true));

        try {
            await service.api.deleteClientRole(memberId, clientId, role);

            dispatch(storeActions.removeClientMemberRole({ memberId, role }));

            service.analytics.trackEvent('Remove client member role', EVENT_CATEGORY.ADMIN);

            const { id } = getUserProfile(getState());
            if (id === memberId) {
                await dispatch(loadUserProfile());
            }
        } catch (err) {
            showErrorSnackbar(getErrorText(err));
        } finally {
            dispatch(storeActions.setClientMembershipsListOperationInProgress(false));
        }
    }
};
